import * as React from "react";

import { ApolloClient, withApollo } from "../react-apollo";
import { ShowMore, Timestamp, Trigger } from "../common";
import { Button, Card, Grid } from "../semantic-ui";
import { SessionProps, withSession } from "../session";
import UserLink from "../user/UserLink";
import AcceptChallengeModal from "./AcceptChallengeModal";
import {
  ChallengeFragment,
  challengeReject,
  challengeWithdraw,
} from "../graphql/challenge";

type Props = SessionProps & {
  client: ApolloClient<any>;
  challenge: ChallengeFragment;
  onChange?: (arg0: any) => void;
  fluid?: boolean;
};

class ChallengeCard extends React.Component<Props> {
  render() {
    const { me, sessionQuery, challenge, onChange, ...rest } = this.props;
    let actions = [];
    if (me && me.id === challenge.sender.id) {
      if (challenge.status === "pending") {
        actions.push(
          <Grid.Column key="withdraw">
            <Button fluid basic onClick={this.handleWithdraw}>
              Withdraw
            </Button>
          </Grid.Column>
        );
      }
    } else if (me && me.id === challenge.recipient.id) {
      if (challenge.status === "pending") {
        actions.push(
          <Trigger
            component={Grid.Column}
            key="accept"
            control={(show) => (
              <Button fluid basic positive onClick={show}>
                Accept
              </Button>
            )}
            modal={(isShown, hide) => (
              <AcceptChallengeModal
                show={isShown}
                onHide={() => (challenge.status === "pending" ? hide() : null)}
                onChange={onChange}
                challenge={challenge}
              />
            )}
          />
        );
        actions.push(
          <Grid.Column key="reject">
            <Button fluid basic negative onClick={this.handleReject}>
              Reject
            </Button>
          </Grid.Column>
        );
      }
    }
    const challengeStatus =
      challenge.status !== "pending"
        ? `The challenge was ${challenge.status}.`
        : null;
    return (
      <Card
        color={me && me.id === challenge.recipient.id ? "yellow" : undefined}
        {...rest}
      >
        <Card.Content>
          <Card.Header>
            <UserLink user={challenge.sender} capitalize /> sent{" "}
            <UserLink user={challenge.recipient} /> a challenge.
          </Card.Header>
          <Card.Meta>
            <Timestamp value={challenge.sentAt} />
          </Card.Meta>
          {challengeStatus && (
            <Card.Description>{challengeStatus}</Card.Description>
          )}
          <Card.Description>
            <strong>Sender's color: </strong>
            {challenge.senderColor || "no preference"}
          </Card.Description>
          <Card.Description>
            <strong>Sender's army: </strong>
            {challenge.senderArmy ? (
              <ShowMore trigger="Show" fullContent={challenge.senderArmy} />
            ) : (
              "secret"
            )}
          </Card.Description>
        </Card.Content>
        {actions.length > 0 ? (
          <Card.Content extra>
            <Grid columns="equal">{actions}</Grid>
          </Card.Content>
        ) : null}
      </Card>
    );
  }

  handleWithdraw = (e: React.MouseEvent) => {
    e.preventDefault();

    this.props.client
      .mutate({
        mutation: challengeWithdraw,
        variables: { id: this.props.challenge.id },
      })
      .then(({ data }) => {
        if (this.props.onChange) {
          this.props.onChange(data.challengeWithdraw);
        }
      });
  };

  handleReject = (e: React.MouseEvent) => {
    e.preventDefault();

    this.props.client
      .mutate({
        mutation: challengeReject,
        variables: { id: this.props.challenge.id },
      })
      .then(({ data }) => {
        if (this.props.onChange) {
          this.props.onChange(data.challengeReject);
        }
      });
  };
}

export default withApollo(withSession(ChallengeCard));
